module.exports = __webpack_public_path__ + "static/media/my-detail-gray.8dcfb166.svg";